export class ListSnapshotRecipesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recipes",
            "baseName": "recipes",
            "type": "Array<SnapshotRecipe>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSnapshotRecipesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
